import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

interface LoginRequestType {
  email: string;
  password: string;
}

interface LoginResponseType {
  token: string;
}

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponseType, LoginRequestType>({
      query: (credentials) => ({
        url: `${BASE_SERVER_PATH}/api/users/login`,
        method: "POST",
        body: credentials,
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      }),
    }),
    getMe: builder.query<{ email: string; card_trader_token: string }, void>({
      query: () => ({
        url: `${BASE_SERVER_PATH}/api/users/me`,
        method: "GET",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const { useLoginMutation, useGetMeQuery } = myServerApis;
